import K from '../constants';
import restHelpers from '../helpers/restHelper';

const getAllFn = ({ page = 1, size = 10, sort = '', order = '', filters, query }) => restHelpers.withBearer.get(`${K.API_URL}/orders?page=${page - 1}&size=${size}${sort !== '' && order !== '' ? `&sort=${sort}&order=${order}` : ''}${filters ? `&${filters}` : ''}${query ? `&q=${query}` : ''}`, { });
const getAvailableVehiclesFn = () => restHelpers.withBearer.get(`${K.API_URL}/cars/get-all?_=${Math.round(new Date().getTime() / (1000 * 10 * 60))}`, {});
const createOrderFn = ( carId, externalOfferId, externalOrderId, description) => restHelpers.withBearer.post(`${K.API_URL}/orders`, { data: { carId, externalOfferId, externalOrderId, description } });
const editOrderFn = ( id, carId, externalOfferId, externalOrderId, description) => restHelpers.withBearer.put(`${K.API_URL}/orders/${id}`, { data: { carId, externalOfferId, externalOrderId, description } });
const deleteOrderFn = id => restHelpers.withBearer.delete(`${K.API_URL}/orders/${id}`, { });
const acceptOrderFn = (id, body) => restHelpers.withBearer.put(`${K.API_URL}/orders/${id}/accept`, { data: body });
const declineOrderFn = id => restHelpers.withBearer.put(`${K.API_URL}/orders/${id}/decline`, { data: {} });
const uploadOrderFileFn = (id, fileList) => restHelpers.withBearer.file(`${K.API_URL}/orders/${id}/file`, { data: fileList });

export default {
  getAll: getAllFn,
  getAvailableVehicles: getAvailableVehiclesFn,
  createOrder: createOrderFn,
  editOrder: editOrderFn,
  deleteOrder: deleteOrderFn,
  acceptOrder: acceptOrderFn,
  declineOrder: declineOrderFn,
  uploadOrderFile: uploadOrderFileFn
};



// WEBPACK FOOTER //
// ./src/services/orders.js